import { useState } from "react";
import * as kudosApi from "../services/apis/KudosApi";
import { useWallet } from "../services/wallet/useWallet";

const useClaimKudos = () => {
  const { addresses } = useWallet();
  const [claiming, setClaiming] = useState(false);

  const claimKudos = async (
    nftid: string,
    signature: string,
    discordUserId?: string,
  ) => {
    const tokenId = parseInt(nftid);

    try {
      setClaiming(true);
      if (discordUserId) {
        await kudosApi.claimDiscordKudos(tokenId, {
          claimingAddress: addresses[0].address,
          signature,
          discordUserId,
        });
      } else {
        await kudosApi.claimKudos(tokenId, {
          claimingAddress: addresses[0].address,
          signature,
        });
      }

      setClaiming(false);
    } catch (error) {
      setClaiming(false);
      throw error;
    }
  };

  return {
    claiming,
    claimKudos,
  };
};

export default useClaimKudos;
